import React from "react";
import { ToastContainer } from "react-toastify";
import { LuX } from "react-icons/lu";
import "react-toastify/dist/ReactToastify.css";
import "./Toaster.css";

// One toaster for the whole app (mounted in App.js). Pages just call
// toast.success(...) / toast.error(...).
const CloseButton = ({ closeToast }) => (
  <button type="button" className="app-toaster-close" onClick={closeToast} aria-label="Dismiss">
    <LuX aria-hidden="true" />
  </button>
);

const Toaster = () => (
  <ToastContainer
    className="app-toaster"
    position="top-right"
    autoClose={3500}
    hideProgressBar
    newestOnTop
    closeOnClick={false}
    pauseOnHover
    pauseOnFocusLoss
    draggable={false}
    closeButton={<CloseButton />}
  />
);

export default Toaster;
